import { useEffect } from 'react';
import { useStore } from '../store/store';
import { useFetch } from '../hooks/useFetch';

import { Ajax } from './Ajax';
import { AuthAction, SalesApiAuthActions, FetchPackageAction, PackagesActions, SalesActions } from '../store/actions';
import { CompletedSaleDTO, SalesDTO } from '../types';

export type AuthenticationResponse = {
  token: string;
};

export const useAuthenticate = () => {
  const { state, dispatch } = useStore();
  const skip = !!state.auth.token;
  const { data, error, fetch } = useFetch('/adressesok/api/authenticate', skip);
  useEffect(() => {
    const authResponse = data as AuthenticationResponse;
    const token = authResponse?.token;
    if (token) {
      dispatch({ type: SalesApiAuthActions.TOKEN_SET, payload: token } as AuthAction);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      dispatch({ type: SalesApiAuthActions.TOKEN_RESET });
    }
  }, [error]);
  const authenticate = () => fetch('/adressesok/api/authenticate');
  return {
    authenticate
  };
};

export const fetchSalesPackagesForValidAddressId = (validAddressId: number, dispatch: any, token: string) => {
  dispatch({ type: PackagesActions.FETCH_PACKAGES_INIT });
  const authHeader = {
    headers: { Authorization: 'Bearer ' + token }
  };
  Ajax.get(`/adressesok/api/packages/${validAddressId}`, { ...authHeader })
    .then(data => {
      dispatch({ type: PackagesActions.FETCH_PACKAGES_SUCCESS, payload: data } as FetchPackageAction);
    })
    .catch(err => {
      dispatch({ type: PackagesActions.FETCH_PACKAGES_ERROR });
    });
};

export const commitSaleForCustomerAndAddress = (salesDTO: SalesDTO, dispatch: any, token: string) => {
  dispatch({ type: SalesActions.COMMIT_SALE_INIT });
  const authHeader = {
    headers: { Authorization: 'Bearer ' + token }
  };
  Ajax.post('/adressesok/api/sale/', { ...salesDTO }, { ...authHeader })
    .then(res => {
      const completedSaleDTO = res as CompletedSaleDTO;

      dispatch({ type: SalesActions.COMMIT_SALE_SUCCESS, payload: completedSaleDTO.zendeskTicketId });
    })
    .catch(err => {
      console.warn('Commiting sale failed', err);
      dispatch({ type: SalesActions.COMMIT_SALE_ERROR });
    });
};
